function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.775 14.2934L9.312 13.5934C9.12222 13.5394 8.98197 13.3788 8.954 13.1834L8.747 11.7264C9.81412 11.2387 10.499 10.1737 10.5 9.00044V7.62644C10.5252 5.97344 9.24251 4.59459 7.592 4.50044C6.78053 4.47554 5.99362 4.78058 5.41095 5.34591C4.82829 5.91124 4.49962 6.68859 4.5 7.50044V9.00044C4.501 10.1737 5.18588 11.2387 6.253 11.7264L6.046 13.1794C6.01803 13.3748 5.87778 13.5354 5.688 13.5894L3.225 14.2894C2.796 14.4121 2.5002 14.8042 2.5 15.2504V17.5004H12.5V15.2544C12.4998 14.8082 12.204 14.4161 11.775 14.2934Z",
  stroke: "#00AEFF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.5 17.5005H17.5V14.2815C17.5 13.8228 17.1879 13.4229 16.743 13.3115L13.826 12.5825C13.6285 12.5332 13.4806 12.369 13.452 12.1675L13.247 10.7265C14.3141 10.2388 14.999 9.17374 15 8.00046V6.62646C15.0252 4.97346 13.7425 3.59461 12.092 3.50046C11.5345 3.4832 10.9832 3.62172 10.5 3.90046",
  stroke: "#00AEFF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgGenderIcon = function SvgGenderIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGenderIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/genderIcon.846b3663.svg";
export { ForwardRef as ReactComponent };